<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="onNoClick()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span class="header-title">
        <mat-icon class="header-icon">settings</mat-icon>
        {{ 'ManageFeatures' | translate }}
      </span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-0">
  <div class="table-header">
    <div class="header-content">
      <h3 class="table-title">
        <mat-icon class="table-icon">list</mat-icon>
        {{ 'FeaturesList' | translate }}
      </h3>
      <div class="header-actions">
        <button (click)="addNewFeature()"
                [disabled]="isAddingNew"
                class="add-btn"
                color="primary"
                mat-raised-button>
          <mat-icon>add_circle</mat-icon>
          {{ 'AddFeature' | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="table-container">
    <div class="table-wrapper">
      <table [dataSource]="dataSource"
             class="features-table"
             mat-table>
        <ng-container matColumnDef="additive">
          <th *matHeaderCellDef
              class="table-header-cell"
              mat-header-cell>
            {{ 'Additive' | translate }}
          </th>
          <td *matCellDef="let element"
              class="table-cell"
              mat-cell>
            @if (!isEditing(element)) {
              <div class="display-value">
                @if (element.additiveTitle) {
                  <span class="value-text">{{ element.additiveTitle }}</span>
                } @else {
                  <span class="empty-value">{{ 'SelectAdditive' | translate }}</span>
                }
              </div>
            } @else {
              <app-frontend-select
                [(value)]="element.additive"
                [controller]="'additives'"
                [displayKey]="'Title,TypeTitle'"
                [fieldName]="'AdditiveId'"
                [isMultiple]="false"
                [method]="'get'"
                [microservice]="Constant.getFoodShop()"
                [protocolMethod]="'POST'"
                [required]="true"
                [searchOnKey]="'Title'"
                [selectedOptions]="[element.additives]"
                [title]="'Additives'"
                [version]="'v1'"
                class="inline-select">
              </app-frontend-select>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="feature">
          <th *matHeaderCellDef
              class="table-header-cell"
              mat-header-cell>
            {{ 'Feature' | translate }}
          </th>
          <td *matCellDef="let element"
              class="table-cell"
              mat-cell>
            @if (!isEditing(element)) {
              <div class="display-value">
                @if (element.featureTitle) {
                  <span class="value-text">{{ element.featureTitle }}</span>
                } @else {
                  <span class="empty-value">{{ 'SelectFeature' | translate }}</span>
                }
              </div>
            } @else {
              <app-frontend-select
                [(value)]="element.feature"
                [controller]="'attributes'"
                [displayKey]="'AttributeTitle'"
                [fieldName]="'AttributeId'"
                [isMultiple]="false"
                [method]="'get'"
                [microservice]="Constant.getFoodShop()"
                [protocolMethod]="'POST'"
                [required]="true"
                [searchOnKey]="'AttributeTitle'"
                [selectedOptions]="[element.features]"
                [title]="'Attributes'"
                [version]="'v1'"
                class="inline-select">
              </app-frontend-select>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="price">
          <th *matHeaderCellDef
              class="table-header-cell"
              mat-header-cell>
            {{ 'Price' | translate }}
          </th>
          <td *matCellDef="let element"
              class="table-cell price-cell"
              mat-cell>
            <div *ngIf="!isEditing(element)"
                 class="display-value">
              <span *ngIf="element.price; else noPrice"
                    class="price-display">
                <span class="price-value">{{ element.price | number:'1.0-0' }}</span>
                <span class="currency">ریال</span>
              </span>
              <ng-template #noPrice>
                <span class="empty-value">{{ 'EnterPrice' | translate }}</span>
              </ng-template>
            </div>
            <app-frontend-input *ngIf="isEditing(element)"
                                [(value)]="element.price"
                                [required]="true"
                                [thousandSeparator]="true"
                                [title]="'Price'"
                                class="inline-input"
                                type="text">
            </app-frontend-input>
          </td>
        </ng-container>
        <ng-container matColumnDef="maxCapacity">
          <th *matHeaderCellDef
              class="table-header-cell"
              mat-header-cell>
            {{ 'MaxCapacity' | translate }}
          </th>
          <td *matCellDef="let element"
              class="table-cell capacity-cell"
              mat-cell>
            @if (!isEditing(element)) {
              <div class="display-value">
                @if (element.maxCapacity) {
                  <span class="capacity-badge">{{ element.maxCapacity }}</span>
                } @else {
                  <span class="empty-value">{{ 'EnterCapacity' | translate }}</span>
                }
              </div>
            } @else {
              <app-frontend-input
                [(value)]="element.maxCapacity"
                [required]="true"
                [title]="'MaxCapacity'"
                class="inline-input"
                type="number">
              </app-frontend-input>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef
              class="table-header-cell actions-header"
              mat-header-cell>
            {{ 'Actions' | translate }}
          </th>
          <td *matCellDef="let element"
              class="table-cell actions-cell"
              mat-cell>
            @if (!isEditing(element)) {
              <div class="action-buttons">
                <button (click)="editFeature(element)"
                        class="action-button edit-btn"
                        mat-icon-button
                        title="{{ 'Edit' | translate }}">
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="deleteFeature(element.id)"
                        class="action-button delete-btn"
                        mat-icon-button
                        title="{{ 'Delete' | translate }}">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            } @else {
              <div class="edit-actions">
                <button (click)="saveFeature(element)"
                        class="action-button save-btn"
                        mat-icon-button
                        title="{{ 'Save' | translate }}">
                  <mat-icon>save</mat-icon>
                </button>
                <button (click)="cancelEditing()"
                        class="action-button cancel-btn"
                        mat-icon-button
                        title="{{ 'Cancel' | translate }}">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div>
            }
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns"
            class="table-header-row"
            mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns;"
            [class.editing-row]="isEditing(row)"
            class="table-row"
            mat-row></tr>
      </table>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (click)="onNoClick()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
